import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { PARAGRAPH } from '../constants';
import type { ParagraphElement } from '../types';

export const isParagraph = isElementType<ParagraphElement>(PARAGRAPH);
